import React, { useRef, useState } from "react";

export default function Index({ data, setPopupData }) {
  const [hovered, setIsHovered] = useState(false);
  const timerRef = useRef();
  const imgRef = useRef();

  const onHoverHandle = () => {
    let index = 0;
    setIsHovered(true);
    // timerRef.current = setInterval(() => {
    //   imgRef.current.src = data.hoverImgs[index];
    //   if (index == data.hoverImgs.length - 1) {
    //     index = 0;
    //   } else index++;
    // }, 1000);
  };

  const onHoverLeaveHandle = () => {

    // clearInterval(timerRef.current);
    // imgRef.current.src = data.displayImg;
    setIsHovered(false);

  };

  return (
    <div
      className="d-flex flex-column position-relative img-flash-card-wrapper"
      onMouseOver={onHoverHandle}
      onMouseLeave={onHoverLeaveHandle}
    >
      <img
        ref={imgRef}
        className="w-100 story-img"
        src={data.displayImg}
        alt={data.city}
      />
      <div className="story-overlay"></div>
      <div
        className={`w-100 story-content bottom-0 position-absolute flex-column gap-3 d-flex ${hovered ? "hovered" : ""
          }`}
      >
        <div className="story-gradient-bg"></div>
        <h3 className="text-white z-1 position-relative story-city-name">
          📍 {data.city}
        </h3>

        <p className="text-white mb-2 z-1 position-relative story-description" dangerouslySetInnerHTML={{__html:data?.cardDesc}}></p>
        <button
          className="story-explore-btn text-white z-1 position-relative"
          onClick={() => setPopupData(data)}
        >
          <span>Explore More</span>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
}
